import { apiClient } from './api-client'
import type {
  AdmissionLoadResponse,
  AdmissionRecoverResponse,
  AdmissionVerifyOldResponse
} from '@/src/types/api.types'

export function loadDraft(email: string, password: string) {
  return apiClient.post<AdmissionLoadResponse>('/admissions/load', {
    username: email,
    password
  })
}

export function recoverDraft(email: string, lang: string) {
  return apiClient.post<AdmissionRecoverResponse>(
    '/admissions/recover',
    { username: email, lingua: lang },
    { language: lang }
  )
}

export function verifyOldDraft(email: string) {
  return apiClient.post<AdmissionVerifyOldResponse>('/admissions/verifyold', {
    username: email
  })
}
